var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.112305 0.765248C0.112305 0.64767 0.158789 0.527344 0.249023 0.437109C0.429492 0.256641 0.724805 0.256641 0.905273 0.437109L7.08223 6.61406L13.1689 0.527344C13.3494 0.346875 13.6447 0.346875 13.8252 0.527344C14.0057 0.707812 14.0057 1.00312 13.8252 1.18359L7.41035 7.60117C7.22988 7.78164 6.93457 7.78164 6.7541 7.60117L0.249023 1.09609C0.156055 1.00312 0.112305 0.885547 0.112305 0.765248Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownNews);
export default __webpack_public_path__ + "static/media/down_news.cc247697df4fd11f7eaed462f36a4427.svg";
export { ForwardRef as ReactComponent };